import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VLayout,
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        VDialog,
        {
          attrs: { persistent: "", width: "400px" },
          model: {
            value: _vm.isOpen,
            callback: function ($$v) {
              _vm.isOpen = $$v
            },
            expression: "isOpen",
          },
        },
        [
          _c(
            VCard,
            { staticClass: "common-dialog" },
            [
              _c(VCardTitle, { staticClass: "text-h5 font-weight-bold" }, [
                _c("div", [
                  _vm._v(
                    "\n          " + _vm._s(_vm.headerText) + "\n        "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(VDivider, { staticClass: "ml-3 mr-3" }),
              _vm._v(" "),
              _c(VCardText, { staticClass: "body" }, [_vm._t("body")], 2),
              _vm._v(" "),
              _c(VDivider, { staticClass: "mt-2 ml-3 mr-3" }),
              _vm._v(" "),
              _c(
                VCardActions,
                { staticClass: "btn-group" },
                [
                  _c(
                    VBtn,
                    {
                      staticClass: "text-decoration-underline",
                      attrs: { text: "", primary: "", depressed: "" },
                      on: { click: _vm.emitCancel },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("actions.cancel")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    VBtn,
                    {
                      staticClass: "ok-btn",
                      attrs: { disabled: _vm.okBtnDisabled },
                      on: { click: _vm.emitOk },
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(_vm.okBtnText) + "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }